import React from 'react';
import { Select } from 'antd';
import { useLanguage, LanguageConfig } from './LanguageContext';
import './LanguageSwitcher.scss';

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage, supportedLanguages, getCurrentLanguageConfig } = useLanguage();

  const handleLanguageChange = (value: string) => {
    setLanguage(value as any);
  };

  // 渲染选项
  const renderOption = (lang: LanguageConfig) => (
    <Select.Option key={lang.code} value={lang.code}>
      <div className="language-option">
        <span className="language-native">{lang.nativeName}</span>
        <span className="language-english">({lang.name})</span>
      </div>
    </Select.Option>
  );

  return (
    <div className="language-switcher">
      <Select
        value={language}
        onChange={handleLanguageChange}
        size="small"
        className="language-select"
        dropdownClassName="language-dropdown"
      >
        {supportedLanguages.map(renderOption)}
      </Select>
    </div>
  );
};

export default LanguageSwitcher;